import { render, staticRenderFns } from "./calendarProdTabItem.vue?vue&type=template&id=44ec33b2"
import script from "./calendarProdTabItem.vue?vue&type=script&lang=js"
export * from "./calendarProdTabItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports